<template>
  <button
    v-if="type == 'button'"
    class="flex items-center justify-center text-white font-bold gap-3 rounded-xl whitespace-nowrap"
    :class="{
      'button-primary': primary,
      'button-secondary': secondary,
      'button-tertiary': tertiary,
      'button-danger': danger,
      'bg-gray-800': disabled,
      'text-xs py-2 px-3': small,
      'text-sm py-3 px-5': medium,
      'text-base py-3 px-5': large,
      'w-full': full,
      'cursor-not-allowed button-disabled': disabled || isLoading,
    }"
    :disabled="disabled"
  >
    <slot name="icon" />
    <h1 v-if="!isLoading">{{ text }}</h1>
    <IconLoader v-else />
  </button>
  <a
    v-else
    :href="link"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center justify-center text-white font-bold gap-3 rounded-xl whitespace-nowrap"
    :class="{
      'button-primary': primary,
      'button-secondary': secondary,
      'button-tertiary': tertiary,
      'button-danger': danger,
      'bg-gray-800': disabled,
      'text-xs py-2 px-3': small,
      'text-sm py-3 px-5': medium,
      'text-base py-3 px-5': large,
      'w-full': full,
      'cursor-not-allowed button-disabled': disabled || isLoading,
    }"
    :disabled="disabled"
  >
    <slot name="icon" />
    <h1 v-if="!isLoading">{{ text }}</h1>
    <IconLoader v-else />
  </a>
</template>
<script>
import IconLoader from "../../icons/IconLoader.vue";
export default {
  name: "Button",
  components: {
    IconLoader,
  },
  props: {
    text: {
      type: String,
    },
    primary: {
      type: Boolean,
    },
    secondary: {
      type: Boolean,
    },
    tertiary: {
      type: Boolean,
    },
    danger: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    medium: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
    full: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
    },
    type: {
      type: String,
      default: "button",
    },
    link: {
      type: String,
      default: "/",
    },
  },
};
</script>
